import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CererePriorityService } from "src/app/platform/nomenclatoare/cerere-priority/cerere-priority.service";
import { CereriService } from "../cereri.service";
import { NotificationService } from "src/app/services/notification.service";
import { PermissionsService } from "src/app/services/permissions.service";
import { initializeEditor } from "src/app/utils/storage/editorConfig";
import { helper } from "src/environments/helper";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { Generic } from "src/app/interfaces/generic.interface";
import { finalize, map } from "rxjs";
import { MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { FunctiiService } from "src/app/platform/nomenclatoare/functii/functii.service";
import { CerereTypeService } from "src/app/platform/nomenclatoare/cerere-type/cerere-type.service";
@Component({
  selector: "app-add-cerere",
  templateUrl: "./add-cerere.component.html",
  styleUrls: ["./add-cerere.component.scss"],
})
export class AddCerereComponent implements OnInit {
  form!: FormGroup;
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  successTitle: string = helper.dialogConfig.headers.success;
  successIcon: string = helper.dialogConfig.icons.success;
  successType: string = helper.dialogConfig.icons.success;
  editorConfig!: AngularEditorConfig;
  requestPriorities: Generic[] = [];
  isLoading: boolean = false;

  uploadedFileNames: string[] = [];
  departament!: any[];
  cerereType!: any[];

  constructor(
    private dialogRef: MatDialogRef<AddCerereComponent>,
    public cereriPrioritiesService: CererePriorityService,
    private fb: FormBuilder,
    private cereriService: CereriService,
    private notificationService: NotificationService,
    public permissionsService: PermissionsService,
    public toastr: ToastrService,
    public functieService: FunctiiService,
    public cerereTypeService: CerereTypeService
  ) {}

  defaultChoiceParameter: { name: string; id: string } = {
    name: "-- Alegeți --",
    id: "-1",
  };
  files: any = {
    files_mesagerie_cetatean: [],
  };
  uploading: any = {
    files_mesagerie_cetatean: false,
  };

  ngOnInit(): void {
    this.editorConfig = initializeEditor();
    this.loadRequestPriorities();
    this.loadDepartament();
    this.loadCerereType();
    this.form = this.fb.group({
      id_cerere_priority: new FormControl("", Validators.required),
      id_departament: new FormControl("", Validators.required),
      id_user_assigned: new FormControl(""),
      description: new FormControl("", Validators.required),
      subject: new FormControl("", Validators.required),
      id_cerere_type: new FormControl("", Validators.required),
      files: this.fb.array([]),
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  loadRequestPriorities() {
    this.cereriPrioritiesService
      .getCererePriorities()
      .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
      .subscribe((data) => {
        this.requestPriorities = data;
      });
  }

  loadDepartament() {
    this.functieService
      .getFunctii()
      .pipe(
        map((results: any) => [this.defaultChoiceParameter, ...results.data])
      )
      .subscribe((data) => {
        this.departament = data;
      });
  }

  loadCerereType() {
    this.cerereTypeService
      .getList()
      .pipe(
        map((results: any) => [this.defaultChoiceParameter, ...results.data])
      )
      .subscribe((data) => {
        this.cerereType = data;
      });
  }

  onFileSelected(event: any, section: any) {
    const files = event.target.files;
    let filesArray;
    if (files) {
      filesArray = this.form.get("files") as FormArray;
    }

    Array.from(files).forEach((file: any) => {
      if (!this.uploadedFileNames.includes(file.name)) {
        this.uploadedFileNames.push(file.name);
        const fileControl = new FormControl(file);

        filesArray.push(fileControl);
      }
    });
  }

  deleteFile(fileName: string, section: any) {
    const nameIndex = this.uploadedFileNames.indexOf(fileName);
    if (nameIndex > -1) {
      this.uploadedFileNames.splice(nameIndex, 1);
    }
    let filesArray: any;
    filesArray = this.form.get("files") as FormArray;

    // const filesArray = this.sendMessageForm.get('files') as FormArray;
    const fileIndex = filesArray.controls.findIndex(
      (control: any) => control.value.name === fileName
    );
    if (fileIndex > -1) {
      filesArray.removeAt(fileIndex);
    }
  }
  openToast(object: any) {
    const { type, message, title } = object;

    let options = this.toastr.toastrConfig;
    options.progressBar = true;
    options.preventDuplicates = true;
    options.closeButton = true;

    const inserted = this.toastr.show(
      message,
      title,
      options,
      options.iconClasses[type]
    );
  }

  removeFile(index: number) {
    const files = this.form.get("files") as FormArray;
    if (index > -1 && index < files.length) {
      files.removeAt(index);
    }
  }

  addFile(event: any, key: "file") {
    event.eventPreventDefault = true;
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.files) {
      return;
    }

    const files = inputElement.files;

    // Iterate through the selected files and append them to the 'files' array in the form
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.uploading[key] = true;

      const formData = new FormData();
      formData.append("file", file, file.name);

      this.cereriService.fileUpload(formData).subscribe({
        next: (result: any) => {
          let response =
            typeof result.status_code !== "undefined" ? result : result.error;
          if (typeof response.status_code !== "undefined") {
            if (
              response.status_code == 200 &&
              typeof response.data !== "undefined"
            ) {
              // Handle the uploaded file by adding it to the 'files' array in the form
              const files = this.form.get("files") as FormArray;
              files.push(new FormControl(result.data));

              this.uploading[key] = false;
              this.openToast({
                title: this.successTitle,
                message:
                  helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                type: this.successIcon,
              });
            }
          } else {
            let errorMessage =
              environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
              this.errorTitle,
              errorMessage,
              this.errorIcon
            );
            this.isLoading = false;
            this.uploading[key] = false;
          }
        },
        error: (result: any) => {
          this.isLoading = false;
          this.uploading[key] = false;
          this.onHttpError(result.error);
        },
      });
    }
  }
  onHttpError(res: any, showErrorsInToast: boolean = false) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        if (showErrorsInToast) {
          this.openToast({
            title: this.errorTitle,
            message: msg,
            type: this.errorType,
          });
        } else {
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        }
      });
    } else {
      let errorMessage =
        environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(
        this.errorTitle,
        errorMessage,
        this.errorIcon
      );
    }
  }

  submitForm() {
    this.isLoading = true;

    console.log(this.form.value);
    this.cereriService
      .store(this.form?.value)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }
}
